
import { css, type Config as WinzigConfig } from "winzig";

winzigConfig: ({
	output: "../",
	appfiles: "appfiles",
	css: "./global.css",
	noCSSScopeRules: true,
	entries: {
		"engine-blink": {
			src: "./engines/blink.ts",
			preload: false,
		},
		"engine-webkit": {
			src: "./engines/webkit.ts",
			preload: false,
		},
		"engine-gecko": {
			src: "./engines/gecko.ts",
			preload: false,
		},
	},
}) satisfies WinzigConfig;

export interface LogicalDOMRect {
	inlineStart?: number;
	blockStart?: number;
	inlineSize?: number;
	blockSize?: number;
};

export type CaretHandler = (range: Range) => {
	caretRect: LogicalDOMRect;
	fontStyle: string;
};

export interface Elements {
	editor: HTMLElement;
};

let handleCaret: CaretHandler;

// const $ = /** @type {Elements} */ (new Proxy({}, {
// 	get(_, /** @type {string} */ name) {
// 		const id = name.replaceAll(/(?<upperCaseLetter>\p{Lu})/ug, "-$<upperCaseLetter>").toLowerCase();
// 		console.log(id);
// 	},
// }));

{
	const child = <div></div>;
	const div = <div>
		{child}
		{css`
			& {
				position: absolute;
				pointer-events: none;
			}

			&::selection {
				color: red;
			}
		`}
	</div>
	document.body.append(div);
	if (window.getComputedStyle(div, "::selection").color !== window.getComputedStyle(child, "::selection").color) {
		document.documentElement.classList.add("no-highlight-inheritance");
	}
	div.remove();
}

const editor = <div className="editor" id="editor" contentEditable="true" spellcheck={false}>
	<div>Lorem ipsum dolor <span style="text-decoration-line: underline; text-decoration-thickness: 3px; text-decoration-style: dotted; text-decoration-color: limegreen;">sit</span> amet consectetur <u>adipisicing</u> elit. <span style="font-variant: small-caps;">Odit</span> ipsam qui <span style="font-weight: 900; -webkit-text-fill-color: Canvas; -webkit-text-stroke: 2px; paint-order: stroke fill; letter-spacing: -.1em;">ducimus</span> nisi <b>consequatur</b> quod laborum ullam <span style="background-color: color-mix(in srgb, peru, Canvas);">impedit</span>, non aut esse aperiam <s>laboriosam</s> a reprehenderit ratione <a href="#">consequuntur</a> ipsum <span style="border: 1px solid goldenrod;">explicabo</span> sed iste <i>voluptates</i> unde architecto. <span style="text-decoration-line: line-through; text-decoration-style: wavy; text-decoration-color: orangered;">Necessitatibus</span> quo <span style="font-weight: 900; font-family: cursive; color: transparent; background: linear-gradient(to right, deepskyblue, chartreuse) text;">doloribus</span>, consequuntur <u>adipisci <s>repellat</s></u><s> incidunt</s> eum animi eos impedit, eius <span style="color: red;">doloremque</span> veritatis suscipit provident vel. <a href="https://benjaminaster.com/">benjaminaster.com</a> Nisi ipsa iste pariatur corrupti delectus ratione, <span style="text-shadow: 2px 2px 2px red;">voluptatum</span> cupiditate fugit quis <span style="letter-spacing: 1px;">molestias</span>, perspiciatis aut tenetur <span style="text-transform: full-width;">reiciendis</span> ab repellendus qui alias ex quas animi quos libero ut tempore <span style="background: linear-gradient(to bottom right, white 0 49%, black 51% 100%);"><span style="color: white; mix-blend-mode: exclusion;">blanditiis</span></span> nihil. Iure facere aliquid perspiciatis quos dolores fugit enim nesciunt, veniam earum, molestias placeat eveniet culpa quas optio sit. Fuga, ducimus?</div>
	<div>Laboriosam alias, deserunt maiores debitis esse quasi praesentium tempora officiis impedit ipsam, iste veniam asperiores amet quae sequi ipsa deleniti sit sunt dolor velit dicta vel? Odit est earum dignissimos doloribus possimus dolore amet itaque voluptate illum neque laboriosam porro vitae sint sunt, distinctio labore et ab nisi fugiat harum quisquam blanditiis molestias? Fugit commodi ad illo molestias nesciunt? Et sunt accusamus dolore minima earum explicabo inventore voluptatum similique ducimus. Dolor, dolorem repellendus? Ab sapiente beatae consequatur hic cupiditate dolorem corrupti quidem voluptates vero quisquam pariatur illo, suscipit voluptatibus saepe eveniet maiores explicabo ut. Eligendi quibusdam officiis maxime corporis accusantium.</div>
	<div>Cumque accusantium facilis, similique tempora aut fugit architecto sed possimus beatae! Numquam reprehenderit corporis quidem id impedit praesentium itaque obcaecati, dolores ipsam, ea ullam amet, inventore perspiciatis aspernatur voluptates sed pariatur delectus doloremque modi veniam? Exercitationem consequatur maiores voluptatem iusto dolorum, minus facilis temporibus culpa fugiat ex id laboriosam totam, aspernatur atque recusandae libero architecto ratione quam distinctio vel. Perspiciatis fugit, commodi accusamus quos natus at ipsa nihil sit dolorum architecto placeat, necessitatibus nemo magni incidunt pariatur molestias suscipit rerum doloribus voluptatibus temporibus fugiat rem. Asperiores ea, consequuntur repudiandae culpa optio ad ut, cum quaerat repellendus illo, qui natus velit.</div>
	<div>Possimus corporis ipsum voluptas delectus dolores, expedita facilis distinctio ea ullam, recusandae illo quod beatae debitis ducimus obcaecati praesentium, voluptatibus a fuga non doloribus doloremque incidunt deleniti ratione? Ex facilis voluptatum cum! Accusamus iste eligendi facilis, officia saepe impedit consequuntur libero cum vero doloremque exercitationem voluptatibus minima laboriosam modi unde necessitatibus id fugiat. Reprehenderit numquam excepturi modi! Possimus, quis molestias quaerat non accusamus quisquam eveniet aperiam quo est, aut amet dolore ipsa beatae! Hic, porro minima dicta, nulla consectetur asperiores dolores illo soluta eligendi quaerat maxime? Enim vero commodi quasi aliquam, atque, nam incidunt nemo fugiat ex reiciendis quisquam! Modi!</div>
	{css`
		& {
			border-radius: 4px;
			font-size: 1.5rem;
			padding: 2rem;
			border: 1px solid var(--gray-4);
			background-color: light-dark(var(--gray-0), var(--gray-2));
			background-clip: padding-box;
			margin-block: 1rem;
			caret-color: transparent;
			outline: none;
			box-sizing: border-box;
			inline-size: calc(100cqi - 3rem);
			max-inline-size: 60rem;
			margin-inline: auto;

			&::selection, :root.no-highlight-inheritance & ::selection {
				background-color: transparent;
				color: inherit;
			}

			&::spelling-error, :root.no-highlight-inheritance & ::spelling-error {
				text-decoration-line: underline;
				text-decoration-thickness: 2px;
				text-decoration-style: dotted;
				text-decoration-color: var(--spelling-error);
				text-underline-offset: 3px;
			}
		}

		& > div:not(:last-of-type) {
			margin-block-end: .5rem;
		}
	`}
</div>;

// const isTouch = window.matchMedia("(hover: none)").matches;
// editor.addEventListener("contextmenu", (event) => {
// 	if (isTouch) event.preventDefault();
// });


const selectionsElement = <div className="selections">
	{css`
		& {
			opacity: 15%;
		}
	`}
</div>;
const SelectionHighlight = () => {
	return <div className="selection">
		{css`
			& {
				position: absolute;
				inset-inline-start: calc(var(--inline-start) * 1px);
				inset-block-start: calc(var(--block-start) * 1px);
				inline-size: calc(var(--inline-size) * 1px);
				block-size: calc(var(--block-size) * 1px);
				background-color: var(--text);
				z-index: 1;
				box-sizing: border-box;
				/* border: 1px solid #888f; */
				background-clip: padding-box;
				/* outline: 1px solid #f008; */
				/* outline-offset: 1px; */
				/* border-radius: .2em; */
				/* transition-property: left, top, width, height; */
				/* transition-duration: 70ms; */
			}
		`}
	</div>;
};

const caretsElement = <div className="carets" />;
const Caret = () => {
	return <div className="caret">
		{css`
			& {
				--direction: ltr;
				--writing-mode: horizontal-tb;
				direction: var(--direction);
				writing-mode: var(--writing-mode);

				--thickness: 1px;
				position: absolute;
				inset-inline-start: calc(var(--inline-start) * 1px);
				inset-block-start: calc(var(--block-start) * 1px);
				inline-size: var(--thickness);
				block-size: calc(var(--block-size) * 1px);
				/* background-color: white; */
				/* mix-blend-mode: exclusion; */
				--backdrop-filter: invert(1) contrast(10) grayscale(1);
				-webkit-backdrop-filter: var(--backdrop-filter);
				backdrop-filter: var(--backdrop-filter);
				z-index: 2;
				/* transition-property: inset-inline-start, inset-block-start, block-size, transform;
				transition-duration: 100ms; */
				--duration: 100ms;
				/* inset-block-end: calc(0px - var(--block-start) * 1px - var(--block-size) * 1px); */
				transition:
					inset-inline-start var(--duration) ease-out,
					inset-block-start var(--duration) ease-out,
					block-size var(--duration) ease-out,
					transform var(--duration) ease-out;
			}

			&.italic {
				transform: skewX(-10deg) scaleX(1.2);
			}

			&.blink {
				animation: 1.1s ease-in-out infinite caret-blink;
			}
		`}
	</div>;
};

const overlayContainer = <div className="overlay">
	{caretsElement}
	{selectionsElement}
	{css`
		& {
			position: absolute;
			pointer-events: none;
		}
	`}
</div>;

const isApple = (
	["iphone", "ipad", "macintosh", "macintel", "mac", "macos", "ios", "iphoneos", "ipados"]
).includes((navigator.userAgentData?.platform || navigator.platform).toLowerCase());

let engine = (() => {
	if (navigator.userAgentData?.brands?.some(({ brand }) => brand === "Chromium") || navigator.userAgent.includes(" Chrome/")) return "blink";
	if (navigator.userAgent.includes(" Firefox/")) return "gecko";
	if (navigator.userAgent.includes(" AppleWebKit/")) return "webkit";
	return "blink";
})();

const browserCompatibilitySwitcher = <select id="browser-compatibility">
	<option value="blink">Chromium</option>
	<option value="webkit">WebKit</option>
	<option value="gecko">Firefox</option>
</select> as HTMLSelectElement;

{
	const filePaths: Record<string, string> = {
		blink: import.meta.resolve("$appfiles/engine-blink.js"),
		webkit: import.meta.resolve("$appfiles/engine-webkit.js"),
		gecko: import.meta.resolve("$appfiles/engine-gecko.js"),
	};
	const updateBrowserCompatibility = async () => {
		({ handleCaret } = await import(filePaths[engine]));
		// ({ handleCaret } = await import("./engines/blink.ts"));
	};
	updateBrowserCompatibility();
	browserCompatibilitySwitcher.value = engine;
	browserCompatibilitySwitcher.addEventListener("input", () => {
		if (browserCompatibilitySwitcher.value !== engine) {
			engine = browserCompatibilitySwitcher.value;
			updateBrowserCompatibility();
		}
	});
	browserCompatibilitySwitcher.addEventListener("pointerleave", () => {
		if (browserCompatibilitySwitcher.value !== engine) {
			engine = browserCompatibilitySwitcher.value;
			updateBrowserCompatibility();
		}
	});
}

const documentLanguageSwitcher = <select id="document-language">
	<option value="no-spellcheck">No spellcheck</option>
	<option value="en">English</option>
	<option value="de">Deutsch</option>
	<option value="es">Español</option>
	<option value="fr">Français</option>
	<option value="zh">中文</option>
</select> as HTMLSelectElement;

const selection = document.getSelection();

{
	let documentLanguage = "no-spellcheck";
	const updateDocumentLanguage = async () => {
		if (documentLanguage === "no-spellcheck") {
			editor.spellcheck = false;
			editor.lang = "en";
			document.documentElement.lang = "en";
		} else {
			editor.spellcheck = true;
			editor.lang = documentLanguage;
			document.documentElement.lang = documentLanguage;
		}
	};
	documentLanguageSwitcher.addEventListener("change", () => {
		if (documentLanguageSwitcher.value !== documentLanguage) {
			documentLanguage = documentLanguageSwitcher.value;
			updateDocumentLanguage();
			setTimeout(() => selection.collapse(editor.firstElementChild.firstChild, 0), 1000);
		}
	});
	documentLanguageSwitcher.addEventListener("pointerleave", () => {
		if (documentLanguageSwitcher.value !== documentLanguage) {
			documentLanguage = documentLanguageSwitcher.value;
			updateDocumentLanguage();
			setTimeout(() => selection.collapse(editor.firstElementChild.firstChild, 0), 1000);
		}
	});
}

let carets = 0;

export let lastPressedKey: string;
// let wasAtLineStartPreviously = false;
let currentCaretBlinkingTimeoutId: number;
export let prevCaretRect: LogicalDOMRect;
let warnBeforeClosing = false;

const removeChildren = (element: Element) => {
	// for (const child of [...element.children]) {

	// 	// if (child.localName !== "template") child.remove();
	// }
	element.textContent = "";
};

export const clamp = (min: number, value: number, max: number) => (
	Math.max(min, Math.min(value, max))
);

export let physicalEditorRect: DOMRect;

const _expose = (object: Record<string, any>) => {
	for (const [key, value] of Object.entries(object)) (self as any)[key] = value;
};

const nextTreeNodeNotInside = (node: Node): Node => node.nextSibling ?? nextTreeNodeNotInside(node.parentNode);
export const nextTreeNode = (node: Node) => node.firstChild ?? nextTreeNodeNotInside(node);

const previousTreeNodeNotOutside = (node: Node): Node => node.lastChild ? previousTreeNodeNotOutside(node.lastChild) : node;
export const previousTreeNode = (node: Node) => node.previousSibling ? previousTreeNodeNotOutside(node.previousSibling) : node.parentNode;

_expose({ nextTreeNode, previousTreeNode });

export const getLayoutInfo = (domItem: Range | Element) => {
	// console.log(domItem.commonAncestorContainer)
	const node = domItem instanceof Range ? domItem.commonAncestorContainer : domItem;
	const element = node instanceof Element ? node : node.parentElement;
	const { writingMode, direction } = window.getComputedStyle(element);
	let rects: LogicalDOMRect[] = [...domItem.getClientRects()].map(({ x, y, width, height }) => {
		x -= physicalEditorRect.x;
		y -= physicalEditorRect.y;
		// TODO: actually handle directions and writing modes
		return {
			inlineStart: direction === "ltr" ? x : physicalEditorRect.width - x - width,
			blockStart: y,
			inlineSize: width,
			blockSize: height,
		};
	});
	return { rects, direction, writingMode };
};

const updateHighlighting = () => {
	// console.debug("%cupdate highlighting", "color: cadetblue");

	if (selection.rangeCount === 0) {
		return;
	}

	const selectionRange = selection.getRangeAt(0);

	removeChildren(selectionsElement);

	physicalEditorRect = overlayContainer.getBoundingClientRect();

	if (currentCaretBlinkingTimeoutId) self.clearTimeout(currentCaretBlinkingTimeoutId);

	$handleCaretsOrSelection: if (selection.isCollapsed) {
		if (!editor.contains(selectionRange.startContainer)) {
			carets = 0;
			removeChildren(caretsElement);
			break $handleCaretsOrSelection;
		}

		const { caretRect, fontStyle } = handleCaret(selectionRange);

		const caretElement = (() => {
			if (carets === 0) {
				carets = 1;
				const element = <Caret />;
				caretsElement.append(element);
				return element;
			}
			return caretsElement.querySelector(":scope > .caret");
		})();

		caretElement.style.setProperty("--inline-start", caretRect.inlineStart);
		caretElement.style.setProperty("--block-start", caretRect.blockStart);
		caretElement.style.setProperty("--block-size", caretRect.blockSize);
		caretElement.classList.toggle("italic", fontStyle === "italic");

		caretElement.classList.remove("blink");
		currentCaretBlinkingTimeoutId = self.setTimeout(() => {
			caretElement.classList.add("blink");
			currentCaretBlinkingTimeoutId = null;
		}, 700);

		prevCaretRect = caretRect;
	} else {
		{
			carets = 0;
			removeChildren(caretsElement);
			// wasAtLineStartPreviously = false;
		}

		// console.time("treewalkerfind");
		const container = selectionRange.commonAncestorContainer;
		if (!editor.contains(container)) {
			break $handleCaretsOrSelection;
		}
		const walker = document.createTreeWalker(container);
		while (walker.nextNode() && walker.currentNode !== selectionRange.startContainer);
		// console.timeEnd("treewalkerfind");
		let isStartContainer = true;
		let isEndContainer = false;

		$loop: do {
			if (walker.currentNode === selectionRange.endContainer) isEndContainer = true;
			if (!(walker.currentNode instanceof Text)) continue $loop;
			const range = document.createRange();
			range.setStart(walker.currentNode, isStartContainer ? selectionRange.startOffset : 0);
			range.setEnd(walker.currentNode, isEndContainer ? selectionRange.endOffset : walker.currentNode.length);

			for (let { inlineStart, blockStart, inlineSize, blockSize } of getLayoutInfo(range).rects) {
				const clone = <SelectionHighlight />;
				clone.style.setProperty("--inline-start", inlineStart);
				clone.style.setProperty("--block-start", blockStart);
				clone.style.setProperty("--inline-size", inlineSize);
				clone.style.setProperty("--block-size", blockSize);
				selectionsElement.append(clone);
			}

			if (isEndContainer) break $loop;
			isStartContainer = false;
		} while (walker.nextNode());
	}
};

let highlightAlreadyUpdated = false;
let tooManySelectionchangesMightFollow = false; // circumvent WebKit bug (dispatches 3 selectionchange events)
let prevRealSelectionchangeTime = 0;

document.addEventListener("selectionchange", () => {
	// console.debug("selectionchange", performance.now());

	if (highlightAlreadyUpdated) {
		highlightAlreadyUpdated = false;
		prevRealSelectionchangeTime = performance.now();
		tooManySelectionchangesMightFollow = true;
		return;
	};

	if (tooManySelectionchangesMightFollow) {
		if (performance.now() < prevRealSelectionchangeTime + 20) return;
		tooManySelectionchangesMightFollow = false;
	}

	updateHighlighting();
});

window.addEventListener("resize", updateHighlighting);

editor.addEventListener("keydown", ({ key }: KeyboardEvent) => {
	lastPressedKey = key;
});

window.addEventListener("blur", () => {
	carets = 0;
	removeChildren(caretsElement);
});

window.addEventListener("focus", updateHighlighting);

editor.addEventListener("beforeinput", event => {
	// console.debug("beforeinput", event)
});

const segmenter = new Intl.Segmenter("en", { granularity: "word" });

let wordCount$ = 0;

const updateWordCount = () => {
	wordCount$ = [...segmenter.segment([...editor.children].map(child => child.textContent).join(" "))].filter(i => i.isWordLike).length;
};

editor.addEventListener("input", ({ inputType, ...rest }) => {
	// console.debug("input", inputType);

	// await 0;

	// console.time("checkinputtype")

	warnBeforeClosing = true;

	console.log(inputType, rest);

	if ([
		// https://w3c.github.io/input-events/#interface-InputEvent-Attributes
		"deleteWordBackward",
		"deleteWordForward",
		"deleteSoftLineBackward",
		"deleteSoftLineForward",
		"deleteEntireSoftLine",
		"deleteHardLineBackward",
		"deleteHardLineForward",
		"deleteByDrag",
		"deleteByCut",
		"deleteContent",
		"deleteContentBackward",
		"deleteContentForward",
		"insertLineBreak",
		"insertParagraph",
	].includes(inputType)) {
		// console.timeEnd("checkinputtype");
		updateHighlighting();
	} else {
		// console.timeEnd("checkinputtype");
	}

	if (segmenter) updateWordCount();
});

if (segmenter) updateWordCount();

window.addEventListener("beforeunload", (event) => {
	if (warnBeforeClosing) event.preventDefault();
});

const handleExecCommand = (commandId: ExecCommandCommandId) => {
	highlightAlreadyUpdated = true;
	// console.debug("before execcommand")
	// TODO: replace execCommand() with a non-buggy, non-non-standardized, interoperable, self-made implementation
	document.execCommand(commandId);
	// console.debug("execcommand finished")
	updateHighlighting();
	// console.debug("highlight update after execcommand finished")
};

window.addEventListener("keydown", (event) => {
	if (event.ctrlKey === !isApple && event.metaKey === isApple && !event.altKey) {
		if (event.shiftKey) {
			if (event.key === "S") {
				event.preventDefault();
				handleExecCommand("strikethrough");
			}
		} else {
			if (event.key === "b") {
				event.preventDefault();
				handleExecCommand("bold");
			} else if (event.key === "i") {
				event.preventDefault();
				handleExecCommand("italic");
			} else if (event.key === "u") {
				event.preventDefault();
				handleExecCommand("underline");
			}
		}
	}
});

for (const button of document.querySelectorAll(".header-inner > button[id]")) {
	button.addEventListener("pointerdown", (event) => {
		event.preventDefault();
	});
}

// document.querySelector("#bold").addEventListener("click", () => {
// 	handleExecCommand("bold");
// });

// document.querySelector("#italic").addEventListener("click", () => {
// 	handleExecCommand("italic");
// });

// document.querySelector("#underline").addEventListener("click", () => {
// 	handleExecCommand("underline");
// });

// document.querySelector("#strikethrough").addEventListener("click", () => {
// 	handleExecCommand("strikethrough");
// });

console.log(navigator.userAgent);

export const storage = new class {
	#pathname = new URL(document.baseURI).pathname;
	get(key: string) {
		try {
			return JSON.parse(localStorage.getItem(`${this.#pathname}:${key}`));
		} catch (error) {
			console.error(error);
			return null;
		}
	};
	set(key: string, value: any) {
		localStorage.setItem(`${this.#pathname}:${key}`, JSON.stringify(value));
	};
	remove(key: string) {
		localStorage.removeItem(`${this.#pathname}:${key}`);
	};
};

const themeSwitcherButton = <button id="theme-switcher" title="Toggle light theme">
	{css`
		&::before {
			content: "☀\\FE0E";
		}

		:root[data-theme=light] &::before {
			content: "🌙\\FE0E";
		}
	`}
</button>;

{
	// color theme
	const mediaMatch = window.matchMedia("(prefers-color-scheme: light)");
	const themeInStorage = storage.get("color-theme") ?? "os-default";
	let currentTheme = ((themeInStorage === "os-default" && mediaMatch.matches) || themeInStorage === "light") ? "light" : "dark";
	const themeColorMeta = (document.getElementById("theme-color-meta") ?? {}) as HTMLMetaElement;

	const updateTheme = () => {
		document.documentElement.dataset.theme = currentTheme === "light" ? "light" : "dark";
		const themeColor = window.getComputedStyle(document.documentElement).backgroundColor.trim();
		console.log("theme color:", themeColor);
		themeColorMeta.content = themeColor;
	};
	updateTheme();

	themeSwitcherButton.addEventListener("click", async () => {
		currentTheme = currentTheme === "dark" ? "light" : "dark";
		storage.set("color-theme", ((currentTheme === "light") === mediaMatch.matches) ? "os-default" : currentTheme);
		updateTheme();
	});

	mediaMatch.addEventListener("change", ({ matches }) => {
		currentTheme = matches ? "light" : "dark";
		storage.set("color-theme", "os-default");
		updateTheme();
	});
}

{
	const mediaMatch = window.matchMedia("(hover)");
	const update = () => {
		document.documentElement.classList.toggle("can-hover", mediaMatch.matches);
	};
	mediaMatch.addEventListener("change", update);
	update();
}

const Header = () => {
	return <header>
		<div>
			<div className="inner">
				<img src="./assets/icon.svg" className="icon" alt="icon of Wort" />
				Wort
				{css`
					& {
						display: flex;
						gap: .4rem;
						font-size: .75rem;
						align-items: center;
						box-sizing: border-box;
						block-size: 100%;
						padding-inline: .5rem;
					}

					& .icon {
						inline-size: 16px;
						aspect-ratio: 1;
					}
				`}
			</div>
			{css`
				& {
					box-sizing: content-box;
					min-block-size: env(titlebar-area-height, 2rem);
					padding-block-start: env(titlebar-area-y, 0px);
					padding-inline-start: env(titlebar-area-x, 0px);
					padding-inline-end: calc(100% - env(titlebar-area-x, 100%) - env(titlebar-area-width, 0px));
					-webkit-app-region: drag;
					app-region: drag;

					display: none;
					@media (display-mode: window-controls-overlay) {
						display: block;
					}
				}
			`}
		</div>

		<div className="header-inner">
			<button on:click={() => handleExecCommand("bold")} title="Toggle bold (Ctrl+B)">
				<code><b>B</b></code>
			</button>
			<button on:click={() => handleExecCommand("italic")} title="Toggle italic (Ctrl+I)">
				<code><i>I</i></code>
			</button>
			<button on:click={() => handleExecCommand("underline")} title="Toggle underline (Ctrl+U)">
				<code><u>U</u></code>
			</button>
			<button on:click={() => handleExecCommand("strikethrough")} title="Toggle strikethrough (Ctrl+Shift+S)">
				<code><s>S</s></code>
			</button>
			<div className="space"></div>
			<img src="./assets/icon.svg" className="icon" alt="icon of Wort" on:dblclick={() => {
				if (document.fullscreenElement) document.exitFullscreen();
				else document.documentElement.requestFullscreen();
			}} />
			{css`
				& {
					display: flex;
					margin: 10px;
					margin-block-end: 0;
					padding: 5px;
					background-color: light-dark(var(--gray-0), var(--gray-2));
					border-radius: 9px;
					border-radius: 10px;
					flex-wrap: wrap;
					align-items: center;
					gap: 5px;
					box-shadow: 0 3px 6px light-dark(#0002, #0006);
					position: relative;
					z-index: 1;
					z-index: 2;
				}

				& > .space {
					flex-grow: 1;
				}

				& .icon {
					inline-size: 24px;
					aspect-ratio: 1;
				}
			`}
		</div>

		{css`
			& {
				display: flex;
				flex-direction: column;
				padding-inline: var(--safe-inline-start) var(--safe-inline-end);
				position: relative;
			}

			& :is(button, label) {
				padding-block: 2px;
				padding-inline: 11px;
				border-radius: 5px;
				transition: background-color, border-color, box-shadow;
				transition-duration: .15s;
				border-block: 1px solid transparent;

				/* :root[data-theme=dark] :is(:root.can-hover &:hover, &:active) {
					border-block-start-color: #fff1;
					box-shadow: 0 1px 2px #0006;
				}

				:root.can-hover &:hover:not(:active) {
					background-color: color-mix(in oklch, var(--header), oklch(65% none none) 15%);
				}

				&:active {
					background-color: color-mix(in oklch, var(--header), oklch(65% none none) 10%);
				} */
			}
		`}
	</header>;
};

const Main = () => {
	return <main>
		<div className="editor-container">
			{overlayContainer}
			{editor}
			{css`
				& {
					position: relative;
				}
			`}
		</div>
		{css`
			& {
				flex-grow: 1;
				overflow: auto;
				scroll-behavior: smooth;
				scroll-padding-block: 2rem;
				scrollbar-gutter: stable both-edges;
				container-type: inline-size;
				margin-inline: var(--safe-inline-start) var(--safe-inline-end);
			}
		`}
	</main>;
};

const Footer = () => {
	return <footer lang="en">
		<div className="side">
			<div>
				<span id="word-count">{wordCount$}</span> words
			</div>
			<label>
				Language: {documentLanguageSwitcher}
			</label>
		</div>
		<div className="side">
			<label title="Change the browser compatibility mode">
				Browser Compatibility Mode: {browserCompatibilitySwitcher}
			</label>
			<div>
				{themeSwitcherButton}
			</div>
		</div>

		{css`
			& {
				display: flex;
				flex-wrap: wrap;
				--element-background: var(--gray-1);
				background-color: var(--element-background);
				row-gap: 1px;
				justify-content: space-between;
				--top-border: var(--gray-3);
				border-block-start: 1px solid var(--top-border);
				padding-inline: var(--safe-inline-start) var(--safe-inline-end);
				padding-block-end: var(--safe-block-end);
				isolation: isolate;

				& > .side {
					display: flex;
					gap: 1px;
					box-shadow: 0 1px var(--top-border);

					&:first-child {
						flex-grow: 1;
					}

					& > * {
						/* padding: .1rem .4rem; */
						padding-inline: .4rem;
						position: relative;
						&:not(:last-child)::after {
							content: "";
							background-color: var(--top-border);
							inset-block: 3px;
							inset-inline-end: -1px;
							inline-size: 1px;
							position: absolute;
							display: block;
						}
					}
				}
			}
		`}
	</footer>;
};

;
<html lang="en">
	<head>
		<meta name="robots" content="all" />
		<meta name="author" content="Benjamin Aster" />
		<meta name="description" content="A simple Microsoft Word alternative" />
		<link rel="code-repository" href="https://github.com/BenjaminAster/wort" />
		<meta attr:property="og:image" content="https://benjaminaster.com/wort/assets/screenshot-desktop.png" />
		<meta name="twitter:card" content="summary_large_image" />

		<title>Wort</title>
		<meta attr:property="og:title" content="Wort" />
		<link rel="icon" href="./assets/icon.svg" type="image/svg+xml" sizes="any" />
		<link rel="icon" href="./assets/icon.png" type="image/png" sizes="512x512" />
		<meta name="theme-color" content="#191516" id="theme-color-meta" />
		<link rel="manifest" href="./app.webmanifest" />
	</head>
	<body>
		<div popover="auto"></div>
		<Header />
		<Main />
		<Footer />
	</body>
</html>;
